import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/whatsapp";
import { useState, useEffect } from "react";

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const testSection = document.getElementById("test");
      if (testSection) {
        const rect = testSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        // Hide button when test section is in view (with some margin)
        const isTestInView = rect.top < windowHeight - 100 && rect.bottom > 100;
        setIsVisible(!isTestInView);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ 
        scale: isVisible ? 1 : 0, 
        opacity: isVisible ? 1 : 0 
      }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#600832] hover:bg-[#470628] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-shadow group"
      style={{ pointerEvents: isVisible ? "auto" : "none" }}
    >
      <MessageCircle className="w-6 h-6" />
      <span className="font-medium text-sm hidden sm:inline-block">
        Hablar con un consultor
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
